// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"navbar-module--wrapper--M0AIl","wrapperScrolled":"navbar-module--wrapper-scrolled--3yJKP"};